import Partition from './partition';
import Role from './role';
import Game from './game';
import ClaimRecord from './claimrecord';
import User from './user';
import ClaimRedpacketRecord from './claimredpacketrecord';

export {
  Partition,
  Role,
  Game,
  ClaimRecord,
  User,
  ClaimRedpacketRecord,
};
export default {
  Partition,
  Role,
  Game,
  ClaimRecord,
  User,
  ClaimRedpacketRecord,
};
